export default {
  title: 'Profilo',
  fields: {
    name: {
      label: 'Nome',
      placeholder: 'Inserisci il nome del ristorante',
    },
    short_name: {
      label: 'Nome breve',
      placeholder: 'Inserisci il nome breve del ristorante',
      tooltip:
        'A volte il nome predefinito del ristorante è molto lungo e può contenere informazioni secondarie, quindi in alcuni casi (es. per notifiche più brevi) è necessaria una versione più corta del nome',
    },
    phone_number: {
      label: 'Numero di telefono',
      placeholder: 'Inserisci il numero di telefono del ristorante',
    },
    email: {
      label: 'Email',
      placeholder: "Inserisci l'email del ristorante",
    },
    slug: {
      label: 'Slug',
      placeholder: 'Slug del marchio',
    },
    language: {
      label: 'Lingua',
      placeholder: 'Usa il valore predefinito del gruppo',
      tooltip:
        'La lingua che i clienti vedono sulla vetrina online di questo ristorante, e quella predefinita per il suo personale. Lascia vuoto per seguire la lingua del marchio. Il personale può comunque scegliere la propria lingua per la propria vista.',
    },
    sms_name: {
      label: 'Nome SMS',
      placeholder: 'Nome visualizzato SMS',
    },
    instagram_link: {
      label: 'Link Instagram',
      placeholder: 'Inserisci il link Instagram del ristorante',
    },
    website_link: {
      label: 'Link sito web',
      placeholder: 'Inserisci il link del sito web del ristorante',
    },
    impressum_link: {
      label: 'Link Impressum',
      placeholder: 'Inserisci il link Impressum del ristorante',
    },
    timezone: {
      label: 'Fuso orario',
      placeholder: 'Cerca una città o un fuso orario',
      tooltip:
        "Il fuso orario in cui opera questo ristorante. Determina i timestamp degli ordini, gli orari di apertura e gli slot degli ordini programmati. È stato impostato dall'indirizzo del ristorante al momento della creazione — correggilo qui se è errato.",
    },
    time_format: {
      label: 'Formato ora',
      placeholder: 'Usa il predefinito del paese',
      tooltip:
        'Come vengono visualizzati gli orari al tuo team, nella dashboard e nel portale degli ordini. Lascia vuoto per seguire la convenzione della regione del ristorante.',
      options: {
        '12h': '12 ore (5:30 pm)',
        '24h': '24 ore (17:30)',
      },
    },
    primary_color: {
      label: 'Colore primario',
    },
    restaurant_type: {
      label: 'Tipo di ristorante e modello di servizio',
    },
    cuisine_types: {
      label: 'Categorie alimentari e tipi di cucina',
    },
  },
  test_restaurant: {
    title: 'Ristorante di test',
    description:
      'Rendi questo il tuo ristorante di test per provare stampe, e-mail, ordini e integrazioni in produzione. Continua a funzionare come qualsiasi altro ristorante e non viene mai fatturato. Puoi avere un solo ristorante di test.',
    description_test:
      'Questo è il tuo ristorante di test. Funziona come qualsiasi altro ristorante e non viene mai fatturato. Le e-mail e gli SMS ai clienti sui suoi ordini iniziano con [TEST].',
    mark: 'Contrassegna come ristorante di test',
    remove: 'Rimuovi designazione Test',
    slot_taken: 'Hai già un ristorante di test ({{name}}). Rimuovi prima la designazione Test da quello esistente.',
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    info_updated: 'Impostazioni aggiornate con successo',
  },
};
